module.exports = __webpack_public_path__ + "img/teatro cousino_thumb.f3f6539b.jpg";